import React from 'react';
import { cn } from '../../utils/cn';
import { DocumentLink } from './documents/DocumentLink';

type DocumentItemVariant = 'default' | 'dashboardImportant';

interface DocumentItemProps {
  id: string;
  name: string;
  link: string;
  className?: string;
  actions?: React.ReactNode;
  isImportant?: boolean;
  underlineOnHoverOnly?: boolean;
  variant?: DocumentItemVariant;
}

export function DocumentItem({ id, name, link, className, actions, isImportant = false, underlineOnHoverOnly = false, variant = 'default' }: DocumentItemProps) {
  const isDashboardImportant = variant === 'dashboardImportant';

  const containerClasses = isDashboardImportant
    ? 'border border-condo-light bg-condo-dark lg:hover:bg-condo-light lg:hover:border-condo-dark'
    : (isImportant
      ? 'border border-condo-dark bg-condo-dark lg:hover:bg-condo-light lg:hover:border-condo-dark'
      : 'border border-condo-dark bg-white lg:hover:border-condo-med');

  return (
    <div
      className={cn(
        'flex items-center justify-between w-full p-2 rounded-lg transition-all group',
        containerClasses,
        className
      )}
    >
      <DocumentLink 
        name={name}
        link={link}
        isImportant={isImportant || isDashboardImportant}
        underlineOnHoverOnly={underlineOnHoverOnly}
        showBadge={!isDashboardImportant && isImportant}
        forceLightText={isDashboardImportant}
      />
      {actions}
    </div>
  );
}